export default function () {
    return {
        "nodes": {
            "all_items": {
                "edgeID": 0,
                "optionsID": 5,
            },
            "input_items": {
                "edgeID": 0
            },
            "component": {
                "edgeID": 1
            },
            "custom": {
                "edgeID": 1
            },
            "scoring": {
                "edgeID": 3,
                "optionsID": 9,
            },
            "item_filter": {
                "edgeID": 1,
                "optionsID": 5
            },
            "predictor_first_block": {
                "edgeID": 0,
                "optionsID": 6
            },
            "sorter": {
                "edgeID": 1
            },
            "no_items": {
                "edgeID": 0
            },
            "p_value_range": {
                "edgeID": 1
            },
            "algorithm": {
                "edgeID": 1,
                "optionsID": 7
            },
            "blender": {
                "edgeID": 2,
                "optionsID": 0,
                "multiPort": true
            },
            "switch": {
                "edgeID": 2,
                "optionsID": 1,
                "multiPort": true
            },
            "a_b_test": {
                "edgeID": 2,
                "optionsID": 1,
                "multiPort": true
            },
            "combinator": {
                "edgeID": 2,
                "optionsID": 8,
                "multiPort": true
            },
            "output": {
                "multiPort": true
            },
            "search_first_block": {
                "edgeID": 0,
                "optionsID": 5,
            },
            "editorial": {
                "edgeID": 0,
                "optionsID": 3
            },
            "push": {
                "edgeID": 1,
                "optionsID": 4
            },
            "field_modifier": {
                "edgeID": 1,
                "optionsID": 2
            },
            "context_property_modifier": {
                "edgeID": 1,
                "optionsID": 9
            },
            "context_updater": {
                "edgeID": 1,
                "optionsID": 9
            },
            "context_modifier": {
                "edgeID": 1,
                "optionsID": 9
            },
            "context_to_first": {
                "edgeID": 0,
                "optionsID": 5
            },
            "cache": {
                "edgeID": 1,
                "optionsID": 5
            }
        },
        "edges": [
            {
                "id": 0,
                "outputPorts": 1,
                "inputPorts": 0
            },
            {
                "id": 1,
                "outputPorts": 1,
                "inputPorts": 1
            },
            {
                "id": 2,
                "outputPorts": 1,
                "inputPorts": 2
            },
            {
                "id": 3,
                "outputPorts": 1,
                "inputPorts":
                    {
                        "first-blocks": 0,
                        "algorithms": 1
                    }
            },

        ],
        "options": [
            {
                "id": 0,
                "inputPortData": [
                    {
                        exclude: false,
                        group: 1,
                        itemCount: null,
                        logDecisionValue: "",
                        randomize: false,
                        useUnder: null
                    },
                    {
                        exclude: false,
                        group: 2,
                        itemCount: null,
                        logDecisionValue: "",
                        randomize: false,
                        useUnder: null
                    }
                ],
                "groupData": [],
                "logDecisionName": null,
                "settings": null,
                "totalItemCount": null,
            },
            {
                "id": 1,
                "logDecisionName": null,
                "inputPortData": [],
                "totalItemCount": null,
            },
            {
                "id": 2,
                "attributes": {},
                "xml": "",
                "maxResults": 500
            },
            {
                "id": 3,
                "selectedItems": [],
                "maxResults": 500
            },
            {
                "id": 4,
                "simplePush": {
                    "predicate": {
                        "predicates":
                        [
                            {
                                "comparisonOptions": {
                                    "leftType": "itemProperty",
                                    "leftValue": "itemId",
                                    "operator": "equals",
                                    "rightType": "contextProperty",
                                    "rightValue": "itemId"
                                },
                                "conditionState": true,
                                "operator": "equals",
                                "type": "comparison"
                            }
                        ],
                        "type": "and"
                    },
                    "pushMode": {
                        "pushType": "addToPrediction",
                        "pushParam": "0.1"
                    }
                }
            },
            {
                "id": 5,
                "maxResults": ""
            },
            {
                "id": 6,
                "predictorFirstBlockOptions": {
                    "predictorName": null
                },
            },
            {
                "id": 7,
                "algorithmOptions": {
                    "predictorName": null
                },
                "maxResults": 500
            },
            {
                "id": 8,
                "expression": "",
                "inputPortData": [
                    { "variableName" : 'V1', "dynamicPropertyName": ""},
                    { "variableName" : 'V2', "dynamicPropertyName": ""},
                ]
            },
            {
                "id": 9,
                "maxResults": 500,
                "scoringOptions": {
                    "predictorName": null,
                    "isFirstBlockModeEnabled": true
                }
            }
        ]
    }
}
